import { Component, OnInit } from '@angular/core';
import { BciWkModalService } from '@bci/webkitbci';

@Component({
  selector: 'app-modal-no-internet',
  templateUrl: './modal-no-internet.component.html',
  styleUrls: ['./modal-no-internet.component.scss'],
  standalone: false
})
export class ModalNoInternetComponent implements OnInit {
  constructor(private modal: BciWkModalService) {}

  ngOnInit(): void {
    this.modal.setStyles({
      containerStyle: {
        padding: '32px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        width: '600px',
        height: '380px',
        overflowY: 'hidden',
      },
    });
  }

  close() {
    this.modal.close();
  }
}
